import { render, staticRenderFns } from "./ViewDetailBTongKet.vue?vue&type=template&id=245aaad4&scoped=true"
import script from "./ViewDetailBTongKet.vue?vue&type=script&lang=js"
export * from "./ViewDetailBTongKet.vue?vue&type=script&lang=js"
import style0 from "./ViewDetailBTongKet.vue?vue&type=style&index=0&id=245aaad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245aaad4",
  null
  
)

export default component.exports